module.exports = ":host /deep/ .navbar-nav .dropdown-item {\n  border-bottom: none !important; }\n"